import { render, staticRenderFns } from "./inviter_info.vue?vue&type=template&id=9b0bf3de&scoped=true"
import script from "./inviter_info.vue?vue&type=script&lang=js"
export * from "./inviter_info.vue?vue&type=script&lang=js"
import style0 from "./inviter_info.vue?vue&type=style&index=0&id=9b0bf3de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b0bf3de",
  null
  
)

export default component.exports